setLagerverfuegbarkeitsFarbe(1);

export function setLagerverfuegbarkeitsFarbe(productCount: number) {
	let $lagerverfuegbarkeitenTable = $<HTMLUListElement>("#lagerverfuegbarkeiten-tabelle");
	let lagerverfuegbarkeitenElemente = getLagerverfuebarkeitenElemente($lagerverfuegbarkeitenTable);
	let lagerbestandsSchwellen = lagerverfuegbarkeitenElemente.get().map((li) => Number($(li).data("stueckzahl")));

	if (!$lagerverfuegbarkeitenTable.length) return;

	const lagerbestand = getNeachstGroesserenLagerbestand(productCount, lagerbestandsSchwellen);
	const lagerverfuegbarkeitsElement = lagerverfuegbarkeitenElemente.filter(
		(_, elem) => $(elem).data("stueckzahl") == lagerbestand
	);

	lagerverfuegbarkeitsElement.addClass(lagerbestand == 0 ? "is-orange" : "is-green");
}

function getLagerverfuebarkeitenElemente($lagerverfuegbarkeitenTable: JQuery<HTMLUListElement>): JQuery<HTMLLIElement> {
	return $lagerverfuegbarkeitenTable.find("li");
}

function getNeachstGroesserenLagerbestand(productCount: number, lagerbestandsSchwellen: number[]): number {
	const greater = lagerbestandsSchwellen.filter(tag => tag >= productCount);
	if (greater.length == 0) return 0;
	return Math.min(...greater);
}
